(function shopTheLookOverlay() {
  'use strict';

  if (window.__stlOverlay) return;
  window.__stlOverlay = true;

  const overlay = document.getElementById('stl-overlay');
  if (!overlay) return;

  const body = overlay.querySelector('[data-stl-body]');
  const loading = overlay.querySelector('[data-stl-loading]');
  const closers = overlay.querySelectorAll('[data-stl-close]');

  let lastFocus = null;
  let currentHandle = null;

  // ── Hotspot edge detection (dynamic) ────────────────────────────────────
  // Computed at runtime against real rendered dimensions, not a static
  // Liquid-side percentage guess — the image panel's width is responsive
  // (varies with viewport and whether the side panel is stacked or beside
  // it), so only a browser-side measurement can be genuinely correct at
  // every screen size. Runs once per overlay open; no resize listener.
  //
  // A hotspot's card overflows the image panel if its centered position
  // (pin center ± half the card's real width) would extend past either
  // edge. When it would, the pin gets hotspot--edge-start or
  // hotspot--edge-end, and the matching CSS in hotspots-image.css anchors
  // the card to that edge instead of centering it.

  function applyHotspotEdgeClasses(hotspotsImage) {
    const panelWidth = hotspotsImage.getBoundingClientRect().width;
    if (!panelWidth) return;

    hotspotsImage.querySelectorAll('.hotspot').forEach((hotspot) => {
      const card = hotspot.querySelector('.hotspot__card');
      if (!card) return;

      // visibility: hidden (the card's default state) still lays out and
      // reports real dimensions, unlike display: none — safe to measure here.
      const cardWidth = card.getBoundingClientRect().width;
      if (!cardWidth) return;

      const xPercent = parseFloat(hotspot.dataset.x);
      if (!Number.isFinite(xPercent)) return;

      const pinCenterX = panelWidth * (xPercent / 100);
      const cardHalfWidth = cardWidth / 2;

      hotspot.classList.remove('hotspot--edge-start', 'hotspot--edge-end');

      if (pinCenterX - cardHalfWidth < 0) {
        hotspot.classList.add('hotspot--edge-start');
      } else if (pinCenterX + cardHalfWidth > panelWidth) {
        hotspot.classList.add('hotspot--edge-end');
      }
    });
  }

  // ── Show content from cache ───────────────────────────────────────────────
  // Content is fully server-rendered — hotspot cards, carousel, and add-all
  // button all arrive complete in the cloned node. No fetch, no client-side
  // building. customElements.upgrade runs once, after the clone (with real
  // content already present) is attached to the DOM.

  function showContent(handle) {
    const cache = document.getElementById('stl-content-cache');
    if (!cache) return false;
    const source = cache.querySelector(`[data-stl-content="${handle}"]`);
    if (!source) return false;

    const clone = source.cloneNode(true);
    body.replaceChildren(clone);
    customElements.upgrade(body);

    // Edge detection runs here — synchronously, right after the clone has
    // real layout (overlay.hidden is already false by this point in open(),
    // so geometry is real even though opacity is still 0) but before the
    // rAF-deferred fade-in transition starts. No visible flash.
    const hotspotsImage = body.querySelector('hotspots-image');
    if (hotspotsImage) applyHotspotEdgeClasses(hotspotsImage);

    // Wire up add-to-cart forms already present in the server-rendered markup.
    body.querySelectorAll('[data-hotspot-add-form]').forEach((form) => {
      form.addEventListener('submit', handleAddToCart);

      // hotspots-image.js's document-level click-outside listener only
      // exempts clicks landing exactly on .hotspot__btn or .hotspot__card
      // (evt.target.matches, not .closest) — a click on this form/button,
      // a descendant of .hotspot__card, falls through and closes the
      // active hotspot before our submit handler ever runs. Stopping the
      // click's propagation here (not in the submit handler — a click on a
      // submit button fully bubbles, and closes the card, before the
      // resulting submit event even fires) keeps the fix scoped to this
      // file rather than touching the shared hotspots-image.js.
      form.addEventListener('click', (e) => e.stopPropagation());
    });

    const addAllBtn = body.querySelector('[data-hotspot-add-all]');
    if (addAllBtn) addAllBtn.addEventListener('click', handleAddAllToCart);

    const firstFocusable = body.querySelector(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (firstFocusable) firstFocusable.focus();
    return true;
  }

  // ── Cart drawer section helper ──────────────────────────────────────────
  // Matches the exact pattern used elsewhere in this theme (wishlist.js) for
  // determining which section IDs to request from /cart/add.js so the cart
  // icon bubble and cart drawer can be updated with real rendered HTML.

  function getCartSectionsToRequest() {
    const sectionsToRequest = ['cart-icon-bubble'];
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const drawerSection = cartDrawer.closest('.shopify-section');
      if (drawerSection) {
        const drawerSectionId = drawerSection.id.replace('shopify-section-', '');
        if (drawerSectionId) sectionsToRequest.push(drawerSectionId);
      }
    }
    return sectionsToRequest;
  }

  function dispatchCartEvents(data) {
    document.dispatchEvent(new CustomEvent('on:cart:update', { bubbles: true, detail: { sections: data.sections } }));
    document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { sections: data.sections } }));
  }

  // ── Add to cart handler (single item) ─────────────────────────────────────

  function handleAddToCart(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const btn = form.querySelector('[data-hotspot-add-btn]');
    const label = btn && btn.querySelector('[data-hotspot-btn-label]');

    if (label) label.textContent = 'Adding…';
    btn && btn.setAttribute('disabled', '');

    const data = new FormData(form);
    data.append('sections', getCartSectionsToRequest().join(','));

    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          // Shopify returns { status, description } on failure even with a 200.
          throw new Error(response.description || 'Add to cart failed');
        }

        if (label) label.textContent = 'Added!';

        const cartDrawer = document.querySelector('cart-drawer');
        if (window.__isalbiCartAddSync && typeof window.__isalbiCartAddSync.schedulePostAddDrawerUpdate === 'function') {
          window.__isalbiCartAddSync.schedulePostAddDrawerUpdate({
            cartDrawer,
            data: response,
            openDrawerAfter: true,
          });
        }
        dispatchCartEvents(response);

        setTimeout(() => {
          if (label) label.textContent = 'Add to cart';
          btn && btn.removeAttribute('disabled');
        }, 2000);
      })
      .catch(() => {
        if (label) label.textContent = 'Error — try again';
        btn && btn.removeAttribute('disabled');
      });
  }

  // ── Add all to cart handler ────────────────────────────────────────────────

  function handleAddAllToCart(e) {
    const btn = e.currentTarget;
    const label = btn.querySelector('[data-add-all-label]');
    let items;
    try {
      items = JSON.parse(btn.dataset.items);
    } catch (err) {
      return;
    }
    if (!Array.isArray(items) || items.length === 0) return;

    if (label) label.textContent = 'Adding…';
    btn.setAttribute('disabled', '');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items,
        sections: getCartSectionsToRequest().join(','),
      }),
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.description || 'Add to cart failed');
        }

        if (label) label.textContent = 'Added all to cart!';

        const cartDrawer = document.querySelector('cart-drawer');
        if (window.__isalbiCartAddSync && typeof window.__isalbiCartAddSync.schedulePostAddDrawerUpdate === 'function') {
          window.__isalbiCartAddSync.schedulePostAddDrawerUpdate({
            cartDrawer,
            data: response,
            openDrawerAfter: true,
          });
        }
        dispatchCartEvents(response);

        setTimeout(() => {
          if (label) label.textContent = 'Add all to cart';
          btn.removeAttribute('disabled');
        }, 2000);
      })
      .catch(() => {
        if (label) label.textContent = 'Error — try again';
        btn.removeAttribute('disabled');
      });
  }

  // ── Shareable deep links ────────────────────────────────────────────────
  // ?look={handle} in the URL. Opening via a tile click pushes a new history
  // entry; loading the page with the param already present (i.e. someone
  // followed a shared link) does not push (the URL is already correct as
  // loaded). Closing branches on which case we're in: history.back() when
  // WE pushed the open (so Back naturally lands on the prior, param-free
  // entry and popstate does the actual closing below), replaceState + an
  // immediate close when we didn't (nothing to go "back" to). popstate
  // itself never touches history — it only reads whatever the URL now says
  // and syncs the overlay to match, whether that's from our own
  // history.back() call above or the browser's native Back/Forward.
  //
  // Room Ideas' own backdrop fully covers the tile grid while an overlay is
  // open, so a second tile can never be clicked mid-overlay — sequential
  // opens are always page → look A → (closed) → page → look B, never a
  // deeper stack. Confirmed with Sam rather than assumed; this is why
  // popstate can simply open-or-close-to-match rather than needing any
  // stack-aware content-swapping logic.

  const LOOK_PARAM = 'look';
  let openedViaPush = false;

  function getLookParam() {
    return new URLSearchParams(window.location.search).get(LOOK_PARAM);
  }

  function buildUrlWithLook(handle) {
    const url = new URL(window.location.href);
    if (handle) {
      url.searchParams.set(LOOK_PARAM, handle);
    } else {
      url.searchParams.delete(LOOK_PARAM);
    }
    return url;
  }

  // ── doOpen / doClose — pure DOM/overlay state, no history side effects ───

  function doOpen(handle, trigger) {
    if (!handle) return false;
    lastFocus = trigger || document.activeElement;
    currentHandle = handle;

    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    if (!showContent(handle)) {
      // Bad/unmatched handle (e.g. a stale shared link) — silently fall
      // back to the normal grid rather than showing an error state.
      doClose();
      return false;
    }

    requestAnimationFrame(() => {
      overlay.classList.add('is-open');
    });
    return true;
  }

  function doClose() {
    if (overlay.hidden) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    currentHandle = null;

    const onEnd = (e) => {
      if (e.target !== overlay.querySelector('.stl-overlay__panel')) return;
      overlay.hidden = true;
      body.innerHTML = '';
      overlay.removeEventListener('transitionend', onEnd);

      if (lastFocus && typeof lastFocus.focus === 'function') {
        lastFocus.focus();
      } else {
        const grid = document.querySelector('room-ideas');
        if (grid && typeof grid.focus === 'function') grid.focus();
      }
    };
    overlay.addEventListener('transitionend', onEnd);
  }

  // ── open / close — history-aware public entry points ─────────────────────

  function open(handle, trigger) {
    if (!handle) return;
    const opened = doOpen(handle, trigger);
    if (!opened) return;

    openedViaPush = true;
    history.pushState({ stlLook: handle }, '', buildUrlWithLook(handle));
  }

  function close() {
    if (overlay.hidden) return;

    if (openedViaPush) {
      // Let the resulting popstate event perform the actual doClose() —
      // avoids closing twice and keeps popstate as the single place that
      // reacts to a URL/history change.
      history.back();
    } else {
      history.replaceState(null, '', buildUrlWithLook(null));
      doClose();
    }
  }

  // ── Sync overlay state to whatever the URL currently says ─────────────────
  // Used for both the initial page load (deep link) and every popstate.

  function syncToUrl() {
    const handle = getLookParam();
    if (handle) {
      if (handle !== currentHandle) doOpen(handle, null);
    } else if (currentHandle) {
      doClose();
    }
  }

  window.addEventListener('popstate', () => {
    openedViaPush = false; // arrived here via navigation, not a fresh click
    syncToUrl();
  });

  // Initial load: if a deep link is already present, auto-open without
  // pushing (the URL is already correct as-loaded).
  const initialHandle = getLookParam();
  if (initialHandle) {
    openedViaPush = false;
    doOpen(initialHandle, null);
  }

  // ── Event listeners ───────────────────────────────────────────────────────

  document.addEventListener('click', (e) => {
    const tile = e.target.closest('[data-look-handle]');
    if (!tile) return;
    e.preventDefault();
    open(tile.getAttribute('data-look-handle'), tile);
  });

  closers.forEach((el) => el.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  overlay.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const focusables = overlay.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

})();